var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54492 0.859131C3.68497 0.859131 0.544922 3.99918 0.544922 7.85913C0.544922 11.7191 3.68497 14.8591 7.54492 14.8591C11.4049 14.8591 14.5449 11.7191 14.5449 7.85913C14.5449 3.99918 11.4049 0.859131 7.54492 0.859131Z",
    fill: "#F79138"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0926 6.37579L7.30089 10.1674C7.18713 10.2811 7.03781 10.3384 6.88849 10.3384C6.73917 10.3384 6.58984 10.2811 6.47609 10.1674L4.58029 8.27159C4.35214 8.04355 4.35214 7.67484 4.58029 7.44679C4.80833 7.21864 5.17694 7.21864 5.40509 7.44679L6.88849 8.93019L10.2678 5.55099C10.4958 5.32285 10.8644 5.32285 11.0926 5.55099C11.3206 5.77904 11.3206 6.14764 11.0926 6.37579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.2cc5b4ca285861613213d7db2f6510db.svg";
export { ForwardRef as ReactComponent };